var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"main-content"},[_c('Banner'),_c('Platform'),_c('Partner'),_c('Service')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }